export default __webpack_public_path__ + "static/media/close.9735c21f.svg";